import { render } from "./Main.vue?vue&type=template&id=076739df"
const script = {}
script.render = render

export default script